import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cards from '../../../../Components/Cards/Cards';
import Stats from '../../../../Components/Stats/Stats';
import { getTimeInHrMinAndSecFromMillis } from '../../../../Utils/DateFormatUtils';
import { humanizeNumber } from '../../../../Utils/NumberUtils';
class RecordingDetailsStats extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    viewers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalWatchTimeInMillis: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    averageWatchTimeInMillis: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    averagePercentageViewed: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  render() {
    const {
      viewers = 0,
      totalWatchTimeInMillis = 0,
      averageWatchTimeInMillis = 0,
      averagePercentageViewed = 0,
      isBig
    } = this.props;
    const { t } = this.context;
    const cardArray = [
      {
        uniqueId: 'recording_details_stats_card_views',
        subText: t('recordingDetails.viewers'),
        title: humanizeNumber(viewers),
        moreInfoTooltip: t('header.cardTypes.totalViewersTooltip')
      },
      {
        uniqueId: 'recording_details_stats_card_avgWatchTime',
        subText: t('recordings.avgWatchTime'),
        title: getTimeInHrMinAndSecFromMillis(Math.trunc(totalWatchTimeInMillis)),
        moreInfoTooltip: t('header.cardTypes.avgWatchTimeTooltip')
      },
      {
        uniqueId: 'recording_details_stats_card_avgViewDuration',
        subText: t('recordings.avgViewDuration'),
        title: getTimeInHrMinAndSecFromMillis(Math.trunc(averageWatchTimeInMillis)),
        moreInfoTooltip: t('header.cardTypes.avgViewDurationTooltip')
      },
      {
        uniqueId: 'recording_details_stats_card_avgPercentageViewed',
        subText: t('recordings.avgPercentageViewed'),
        title: `${averagePercentageViewed} %`,
        moreInfoTooltip: t('header.cardTypes.avgPercentageViewed')
      }
    ];
    return isBig ? <Cards contents={cardArray} /> : <Stats contents={cardArray} />;
  }
}
export default RecordingDetailsStats;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/RecordingDetails/Stats/RecordingDetailsStats.js